import React, { useState, useRef } from "react";
import "./CarruselCategorias3.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { configShop } from '../../states/configShop';
//import { Link } from "react-router-dom";
import { Link } from 'react-scroll';
import { FaSearch } from "react-icons/fa";
export const CarrionCategory3 = (props) => {
    const { openCategories, search, setSearch } = props;
    const { dataConfig } = configShop();
    const [showSearch, setShowSearch] = useState(false);

    return (
        <div className="menu">
            {showSearch && (
                <input
                    type="text"
                    className="new-inputConfirmacion-guests"
                    placeholder="Buscar productos..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{
                        padding: "20px",
                        width: "100%",
                        marginTop: "10px",
                        marginBottom: "20px",
                    }}
                />
            )}
            <ul>
                <li>
                    <button
                        onClick={() => {
                            setShowSearch(!showSearch);
                            if (showSearch) setSearch(""); // si se va a ocultar, limpiar input
                        }}
                        style={{
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            fontSize: "16px",
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                            color: dataConfig?.page_menu?.color_text || "#000",
                        }}
                    >
                        <FaSearch />
                    </button>

                </li>
                {openCategories?.map((item) => (
                    <li key={item.uuid}>
                        <Link
                            activeClass="active" style={{ "--btn-font-color": dataConfig?.page_menu?.color_text, "--btn-color": dataConfig?.color_botton }}
                            to={item.uuid}
                            spy={true}
                            smooth={true}
                            offset={-60}
                            duration={500}
                        >
                            {item.name}
                        </Link>
                    </li>
                ))}
            </ul>

        </div>

    );
};
